// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__3dXvX","checkmark":"checkbox_checkmark__o5keG"};